export default __webpack_public_path__ + "static/media/mtn.cdd35b95.svg";